import { cn } from "@core/lib/utils";

interface LabeledDataPointProps {
  containerClassName?: string;
  label?: string;
  labelClassName?: string;
  value?: string | number;
  valueClassName?: string;
}

export const LabeledDataPoint = ({
  containerClassName,
  label,
  labelClassName,
  value,
  valueClassName
}: LabeledDataPointProps) => {
  return (
    <div className={containerClassName}>
      <div>
        <span className={cn("inline-block mb-1 text-sm", labelClassName)}>{label}</span>
      </div>
      <div>
        <span className={cn("border bg-gray-100 px-3 py-2 rounded-[var(--form-radius)] block", valueClassName)}>{value || "N/A"}</span>
      </div>
    </div>
  );
};
